import { EntityUtils } from '@record-it-npm/synchro-client';
import React, { ComponentProps, FunctionComponent, useMemo } from 'react';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { ConstructionSite } from '../../../classes/entities/ConstructionSite/constructionSiteTypes';
import { ConstructionSiteUtils } from '../../../classes/entities/ConstructionSite/ConstructionSiteUtils';
import { ConstructionSiteToSelectListItem } from '../../constructionSite/ConstructionSiteToSelectListItem/ConstructionSiteToSelectListItem';
import { useConstructionSiteSelectedHandler } from './useConstructionSiteSelectedHandler';

export type CreateWorkTimeEntrySelectConstructionSitePageSearchContentProps =
  PropsWithoutChildren<ComponentProps<'div'>> & {
    constructionSites: Array<ConstructionSite>;
    searchText: string;
  };

export const CreateWorkTimeEntrySelectConstructionSitePageSearchContent: FunctionComponent<CreateWorkTimeEntrySelectConstructionSitePageSearchContentProps> =
  React.memo((props) => {
    const { constructionSites, searchText, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    const { handleConstructionSiteSelected } =
      useConstructionSiteSelectedHandler();

    const foundConstructionSites = useMemo(() => {
      if (!searchText) {
        return constructionSites;
      }

      return constructionSites.filter((constructionSite) => {
        return ConstructionSiteUtils.containsSearchText(
          constructionSite,
          searchText
        );
      });
    }, [constructionSites, searchText]);

    return (
      <div {...remainingProps}>
        {foundConstructionSites.map((constructionSite) => (
          <ConstructionSiteToSelectListItem
            key={EntityUtils.getTrackingKey(constructionSite)}
            constructionSite={constructionSite}
            onConstructionSiteSelected={handleConstructionSiteSelected}
            data-testid="CreateWorkTimeEntrySelectConstructionSitePage.ConstructionSiteListItem"
          ></ConstructionSiteToSelectListItem>
        ))}
      </div>
    );
  });
